import React from 'react'
import Header from '../../modules/Header'
import Footer from '../../modules/Footer'
import Container from '../../components/Container'
import Boxes from '../../components/Boxes'
import Box from '../../components/Box'
import Icon from '../../components/Icon'
import { ManageStyled } from './styled'
import { useFetch } from '../../hooks';
import { renderData, parseObjectToArray, getData, sortByInt } from '../../helpers';
import FakeLoaderBox from '../../components/FakeLoaderBox';

const Manage = () => {
  const { response: responseManage, error: errorManage, fetching: fetchingManage } = useFetch({
    url: '/managetiles',
    method: 'GET',
  })

  const renderDataState = renderData({ data: responseManage, error: errorManage, fetching: fetchingManage })

  const sortBoxes = sortByInt({ direct: 'asc', key: 'order' })

  return (
    <ManageStyled>
      <Header />
      <Container>
        <Boxes>
          {
            renderDataState({
              fetching: () => (<FakeLoaderBox numberItems={5} />),
              error: error => <div>{error.toString()}</div>,
              data: data => (
                sortBoxes(parseObjectToArray(getData(data)))
                  .map(box => (
                    <Box
                      key={box.to}
                      to={`/manage/${box.to}`}
                      title={box.label}
                      content={box.icon && <Icon name={box.icon} height="34" width="34" />}
                      icon={box.icon}
                      active={box.showme}
                      bordercolor={box.bordercolor}
                      info={box.info}
                    />
                  ))
              ),
            })
          }
        </Boxes>
      </Container>
      <Footer />
    </ManageStyled>
  )
}

export default Manage
